<template>
    <div>
        <div id="mapcontainer" 
        :style="{ width:  '100%' , height: height+ 'px' }"
        >
        </div>
    </div>
</template>

<script>
export default {
  props: {

      lat:{
        type: String,
        default:''
      },
      lng:{
        type: String,
        default:''
      },

      name:{
        type: String,
        default:''
      },

      height:{
        type: Number,
        default:300
      },

  },

  data () {
    return {
      //dafaultImg: dafaultImg
    }
  },
    mounted() {
        this.init();
    },
    methods:{
      init() {
          //步骤：定义map变量 调用 qq.maps.Map() 构造函数   获取地图显示容器
          //设置地图中心点
          console.log(this.lat)
          console.log(this.lng)
          var myLatlng = new qq.maps.LatLng(this.lat,this.lng);
          //定义工厂模式函数
          var myOptions = {
            zoom: 14,               //设置地图缩放级别
            center: myLatlng,      //设置中心点样式
            mapTypeId: qq.maps.MapTypeId.ROADMAP  //设置地图样式详情参见MapType
          }
          //获取dom元素添加地图信息
          var map = new qq.maps.Map(document.getElementById("mapcontainer"), myOptions);

          var marker = new qq.maps.Label({
              position: myLatlng,
              map: map,
              content:this.name
          });

          
      }
    }
};

</script>

<style lang="scss" scoped>
</style>
